var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item"},[_c('div',{staticClass:"item-header"},[_c('img',{attrs:{"src":_vm.headerBg,"alt":"header-bg"}}),_c('span',{staticStyle:{"position":"absolute"}},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_c('div',{staticClass:"item-bg"},[_c('img',{attrs:{"src":_vm.bodyBg,"alt":"bodyBg-bg"}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }